export const TITULO_PAGINA = 'Boleto Futuro'

export const getProximosMesesBoletoTrimestral = mes => {
  const meses = [
    'janeiro',
    'fevereiro',
    'março',
    'abril',
    'maio',
    'junho',
    'julho',
    'agosto',
    'setembro',
    'outubro',
    'novembro',
    'dezembro'
  ]

  return [ meses[ ( mes % 12 ) ], meses[ ( ( mes + 1 ) % 12 ) ], meses[ ( ( mes + 2 ) % 12 ) ] ]
}
